import { faChevronDown, faChevronRight } from "@awesome.me/kit-cae4660dd3/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useAccordionButton } from "react-bootstrap/esm/AccordionButton";
import AccordionToggleProps from "./accordion-toggle.props";
import eventHelper from "./eventHelper";

const AccordionToggle = (props: AccordionToggleProps) => {
  const [currentIcon, setCurrentIcon] = useState(faChevronRight);
  const updateIcons = () => {
    const isActive = props.activeKey === props.eventKey;
    const newIcon = isActive && currentIcon === faChevronRight ? faChevronDown : faChevronRight;
    setCurrentIcon(newIcon);
  };
  const toggleAccordion = useAccordionButton(props.eventKey, () => {
    if (typeof props.callback === "function") {
      props.callback(props.eventKey);
    }
    updateIcons();
  });

  useEffect(() => updateIcons(), [props.activeKey, props.eventKey]);
  return (
    <div
      {...eventHelper(toggleAccordion)}
      className="accordion-toggle d-flex font-weight-bold h5 py-2 text-gray border-bottom w-100 cursor-pointer"
    >
      <div className="toggle-icon mr-3">
        <FontAwesomeIcon icon={currentIcon} size="sm" />
      </div>
      <div className="toggle-title">{props.body}</div>
    </div>
  );
};

export default AccordionToggle;
